import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Company } from '../models/company.model';

const NAMES = ['TechCorp BV', 'InnovateNL', 'BuildMasters', 'MediaPro', 'FinanceGroup', 'HealthCare+', 'RetailSolutions', 'AgriTech'];
const SECTORS = ['ICT', 'Technologie', 'Bouw', 'Media', 'Financiën', 'Zorg', 'Retail', 'Agrarisch'];
const LOCATIONS = ['Amsterdam', 'Rotterdam', 'Utrecht', 'Den Haag', 'Eindhoven', 'Groningen', 'Tilburg', 'Arnhem'];
const TAGS = ['100+ werknemers', '50-100', 'Scale-up', 'Corporate', 'Innovatief', 'Internationaal', 'Familiebedrijf', 'Start-up'];
const VALUES = ['Innovatie', 'Samenwerking', 'Klantgericht', 'Duurzaamheid', 'Integriteit', 'Diversiteit'];

const FOLLOWED_KEY = 'followedCompanies';

function generateCompanies(count: number): Company[] {
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: NAMES[i % NAMES.length],
    sector: SECTORS[i % SECTORS.length],
    location: LOCATIONS[i % LOCATIONS.length],
    tags: [TAGS[i % TAGS.length], TAGS[(i + 1) % TAGS.length]],
    matchScore: Math.floor(60 + Math.random() * 40),
    isNew: i < 6,
    description: `${NAMES[i % NAMES.length]} is een toonaangevend bedrijf in de sector ${SECTORS[i % SECTORS.length]}. Wij zijn gevestigd in ${LOCATIONS[i % LOCATIONS.length]} en bieden een dynamische werkomgeving.`,
    color: '#89CCDC',
    headerColor: '#89CCDC',
    employees: ['50-100', '100-250', '250-500', '500+'][i % 4],
    founded: `${2005 + (i % 15)}`,
    offices: `${1 + (i % 5)} kantoren`,
    website: 'www.example.com',
    about: `${NAMES[i % NAMES.length]} is opgericht met de visie om de ${SECTORS[i % SECTORS.length].toLowerCase()} sector te transformeren. Wij geloven in innovatie, samenwerking en het creëren van duurzame waarde voor onze klanten en medewerkers.`,
    mission: `Onze missie is om de beste werkgever te zijn in de ${SECTORS[i % SECTORS.length].toLowerCase()} sector en tegelijkertijd bij te dragen aan een betere toekomst.`,
    values: VALUES.slice(0, 3 + (i % 3)),
    vacancies: Array.from({ length: 3 }, (__, j) => ({
      id: i * 100 + j + 1,
      title: ['Frontend Developer', 'Project Manager', 'Data Analyst'][j % 3],
      location: LOCATIONS[i % LOCATIONS.length],
      type: ['Fulltime', 'Parttime', '32 uur'][j % 3],
    })),
    fields: [SECTORS[i % SECTORS.length], SECTORS[(i + 1) % SECTORS.length]],
    addedDate: ['3 dagen geleden', '1 week geleden', '2 weken geleden', 'Vandaag'][i % 4],
  })).sort((a, b) => b.matchScore - a.matchScore);
}

@Injectable({ providedIn: 'root' })
export class CompanyMockService {
  private companies = generateCompanies(100);

  getCompanies(): Observable<Company[]> {
    return of(this.companies);
  }

  getNewCompanies(): Observable<Company[]> {
    return of(this.companies.filter(c => c.isNew));
  }

  getCompanyById(id: number): Observable<Company | undefined> {
    return of(this.companies.find(c => c.id === id));
  }

  getFollowedCompanies(): Observable<Company[]> {
    const saved = localStorage.getItem(FOLLOWED_KEY);
    if (!saved) return of([]);
    return of((JSON.parse(saved) as Company[]).sort((a, b) => b.matchScore - a.matchScore));
  }

  getFollowedIds(): number[] {
    const saved = localStorage.getItem(FOLLOWED_KEY);
    if (!saved) return [];
    return (JSON.parse(saved) as Company[]).map(c => c.id);
  }

  toggleFollowCompany(company: Company): boolean {
    const saved = localStorage.getItem(FOLLOWED_KEY);
    const list: Company[] = saved ? JSON.parse(saved) : [];
    const exists = list.some(c => c.id === company.id);

    if (exists) {
      localStorage.setItem(FOLLOWED_KEY, JSON.stringify(list.filter(c => c.id !== company.id)));
      return false;
    } else {
      list.push(company);
      localStorage.setItem(FOLLOWED_KEY, JSON.stringify(list));
      return true;
    }
  }
}
